<template>
  <div id="app" class="flex flex-col min-h-screen">
    <app-header v-if="!$route.meta.hideHeader" />
    <main class="flex-grow">
      <router-view />
    </main>
    <app-footer v-if="!$route.meta.hideHeader" />
    <!-- 悬浮客服按钮 -->
    <div class="fixed bottom-8 right-8 z-50">
      <button class="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center text-white shadow-2xl hover:scale-110 active:scale-95 transition-all group relative"
        title="在线客服">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
        <span class="absolute right-full mr-4 bg-white text-slate-900 px-4 py-2 rounded-xl text-sm font-bold shadow-xl whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
          在线客服
        </span>
        <span class="absolute top-0 right-0 w-4 h-4 bg-red-500 rounded-full border-4 border-white animate-pulse"></span>
      </button>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'

export default {
  name: 'App',
  components: { AppHeader, AppFooter }
}
</script>
